import React, {useState} from "react";

import propertydef from "./prpdefs";
import {send_edit_cmd} from "../../etc/cmd";
import Propsline from "./detail/propsline";
import {hasAccessory, hasBM} from "../../bidib/bidib_commons";
import {connect} from "react-redux";

const EditPanel = ({item, domain}) => {



    function onChange(key, val, array, arrayindex) {

        if (array && arrayindex) {
            const arrayprop = array
            const index = arrayindex
            const prop = key
            console.log("RAW #############")
            console.log(arrayprop)
            console.log(index)
            console.log(prop)
            console.log("############## RAW")

            if (item[arrayprop] && item[arrayprop][index] && item[arrayprop][index][prop]) {
                item[arrayprop][index][prop] = val
            }

            const cc = {
                id: item.id,
                type: item.type,
                typename: item.typename,
                [arrayprop]: [{
                    id: index,
                    [prop]: val
                }
                ]
            }
            /*console.log("##################")
            console.log(item)
            console.log(cc)
            console.log("##################")*/
            send_edit_cmd(cc)

        } else {
            const cc = {
                id: item.id,
                type: item.type,
                typename: item.typename,
                [key]: val,
            }
            //console.log("##################")
            //console.log(cc)
            //console.log("##################")
            send_edit_cmd(cc)
        }
    }

    function getFields(gr) {

        //console.log("getFields %s", gr)



        let itms = []
        propertydef[gr] && propertydef[gr].map(itm => {
                itms.push(<Propsline key={itm.name + "_" + item.id} itm={itm} item={item} domain={domain}
                                     onChange={onChange}/>)


            }
        )
        return itms
    }

    let itmsc = []
    if (item.typename !== 'module') {
        itmsc = getFields('common')
    }


    let itms = getFields(item.type ? item.type : item.typename)

    return (
        <div
            style={{
                margin: 10,
                padding: 5,
            }}
        >
            {itmsc}
            {itms}
        </div>
    )
}

function mapStateToProps(state, other) {

    const bidib = state.bidib.data.node || []
    const items = state.plan.items || []

    var _domain = {}
    _domain.addr = bidib.filter(itm => itm.type === 'node').map(itm => itm.uid)
    _domain.bmaddr = bidib.filter(itm => hasBM(itm.classid)).map(itm => itm.uid);
    _domain.accaddr = bidib.filter(itm => hasAccessory(itm.classid)).map(itm => itm.uid);
    _domain.streckenblock = items && items.filter(itm => itm.subtype === 'streckenblock' && itm.type === 'bk').map(itm => itm.id);

    return {items: state.plan.items, domain: _domain}
}

export default connect(mapStateToProps)(EditPanel)
